import React from 'react';
import Dashboardsidebar from './Dashboardsidebar';

const Dashboard = () => {
    return (
        <div>
            
            <Dashboardsidebar>
           
            </Dashboardsidebar>
        </div>

    );
};

export default Dashboard;